import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import {
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  IconButton,
  Tooltip,
} from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../../../app/appSlice";
import CoreModal from "../../../../../../app/core/components/CoreModal/CoreModal";
import CoreSpinner from "../../../../../../app/core/components/CoreSpinner/CoreSpinner";
import {
  useGetServiceGroupQuery,
  useGetStudioServicesQuery,
} from "../../../../../../features/api/user/servicesStudioApi";
import {
  useGetTenantQuery,
  useGetTenantServicesQuery,
} from "../../../../../../features/api/user/tenantApi";
import SedeTenant from "./SedeTenant";
import ServiceTenant from "./ServiceTenant";
const SwitchTenant = ({ onClose, registration = {} }) => {
  const dispatch = useDispatch();
  const studioId = useSelector((state) => state.app.studioId);
  const tenantId = useSelector((state) => state.app.tenantId);
  const appConfig = useSelector((state) => state.app.appConfig);
  const adminStudios = useSelector((state) => state.app.adminStudios);

  const [tenant, setTenant] = useState([]);
  const [modalSede, setModalSede] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState();
  const [selectedStudioId, setSelectedStudioId] = useState();
  const [serviceStudio, setServiceStudio] = useState(false);
  const [selectedTenantId, setSelectedTenantId] = useState();

  const isRegistrationNotEmpty =
    registration && Object.keys(registration).length > 0;

  const { data: getTenantList } = useGetTenantQuery(isRegistrationNotEmpty);
  const { data: dataServiceStudio, isLoading: loadingStudio } =
    useGetStudioServicesQuery(selectedStudioId, {
      skip: !selectedStudioId || !selectedStudioId,
    });
  const { data: serviceLevel } = useGetServiceGroupQuery(selectedStudioId, {
    skip: !appConfig?.modules?.services?.serviceTwoLevel || !selectedStudioId,
  });

  //get tenant services list
  const { data: dataTenantService } = useGetTenantServicesQuery(
    { tenantId: selectedTenantId },
    {
      skip: !selectedTenantId,
    }
  );

  useEffect(() => {
    if (getTenantList && getTenantList.Data && adminStudios) {
      const tenants = getTenantList.Data.map((el) => {
        // Trova lo studio corrispondente per tenantId
        const studio = adminStudios.find((studio) => studio.tenantId === el.id);
        if (el.description === "Enasco") {
          return {
            logo: el.logoImageUrl,
            name: el.description,
            privacy: t("PrivacyEnasco"),
            tenantId: el.id,
            primaryColor: el.primaryColor,
            secondaryColor: el.secondaryColor,
            studioName: studio ? studio.studioName : undefined,
            studioId: studio ? studio.studioId : undefined,
          };
        } else {
          return {
            logo: el.logoImageUrl,
            name: "CAF",
            privacy: t("Privacy50&Più"),
            tenantId: el.id,
            primaryColor: el.primaryColor,
            secondaryColor: el.secondaryColor,
            studioName: studio ? studio.studioName : undefined,
            studioId: studio ? studio.studioId : undefined,
          };
        }
      });
      setTenant(tenants);
    }
  }, [getTenantList, adminStudios]);

  // Controllo tra dati del JWT e della CHECK TENANT
  useEffect(() => {
    if (!selectedTenant) return;

    if (isRegistrationNotEmpty) {
      setModalSede(true);
    }

    // if (
    //   !adminStudios.some(
    //     (studio) => studio.studioId === selectedTenant.studioId
    //   )
    // ) {
    //   setModalSede(true);
    //   return;
    // }

    if (!selectedTenant.studioId && !selectedStudioId) {
      setModalSede(true);
      return;
    } else {
      dispatch(
        actions.setTenantId({
          tenantId: selectedTenant.tenantId,
        })
      );
      dispatch(
        actions.setStudioId({
          studioId: selectedTenant.studioId,
        })
      );
      dispatch(
        actions.updateStudioName({
          studioName: selectedTenant.studioName,
        })
      );
      dispatch(
        actions.setLogoImageURL({
          logoImageURL: selectedTenant.logo,
        })
      );
      dispatch(
        actions.setColors({
          primaryColor: selectedTenant.primaryColor,
          secondaryColor: selectedTenant.secondaryColor,
        })
      );
    }
    onClose();

    // facciamo un refresh dei dati dopo la chiusura
    setTimeout(() => {
      window.location.reload();
    }, 750);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminStudios, selectedTenant]);

  const handleCloseSedeModal = () => {
    setModalSede(false);
    setSelectedTenant(null);
  };

  const handleSelectedTenant = (tenant) => {
    setSelectedTenant(tenant);
    setSelectedStudioId(tenant.studioId);
  };

  const hadleOpenService = (param) => {
    setSelectedStudioId(param.studioId);
    setSelectedTenantId(param.tenantId);
    setServiceStudio(true);
  };

  const filterService = appConfig?.modules?.services?.serviceTwoLevel
    ? dataServiceStudio?.Data?.services?.filter(
        (el) => el.practiceServiceCategoryId === null
      )
    : dataServiceStudio?.Data?.services;

  if (loadingStudio) {
    return <CoreSpinner />;
  }

  return (
    <div>
      <div className="flex ">
        <h2 className="w-full p-2 m-1 text-center">Accedi al tuo servizio</h2>
      </div>

      <div className="flex justify-center space-x-8 py-10">
        {tenant?.map((el, idx) => (
          <div key={idx} className="flex flex-col justify-center items-center">
            <Card
              className="flex justify-center items-center text-center"
              sx={{
                width: "10rem",
                height: "10rem",
                borderRadius: "20px",
              }}
              elevation={4}
            >
              <div className="w-full h-full relative ">
                {tenantId === el.tenantId && (
                  <CardActions className="w-full justify-end p-1 absolute z-10">
                    <IconButton disabled size="small">
                      <CheckCircleRoundedIcon className=" text-green-600 " />
                    </IconButton>
                  </CardActions>
                )}
                <CardActionArea
                  disabled={tenantId === el.tenantId}
                  className="w-full h-full"
                  onClick={() => handleSelectedTenant(el)}
                  data-active={tenantId === el.tenantId ? "" : undefined}
                  sx={{
                    height: "100%",
                    "&[data-active]": {
                      backgroundColor: "action.selected",
                      "&:hover": {
                        backgroundColor: "action.selectedHover",
                      },
                    },
                  }}
                >
                  <CardContent className="p-0">
                    <img
                      alt={"logo"}
                      src={el.logo}
                      style={{
                        maxWidth: "8rem",
                        maxHeight: "10rem",
                      }}
                    />
                  </CardContent>
                </CardActionArea>
              </div>
            </Card>
            <div className="w-full flex justify-center pt-4">
              <Tooltip title={t("Info")}>
                <Button
                  className={"btn-round-outline"}
                  onClick={() => hadleOpenService(el)}
                >
                  {t("Services")} {el.name}
                </Button>
              </Tooltip>
            </div>
          </div>
        ))}
      </div>
      <CoreModal
        width={"60%"}
        height={"60%"}
        state={serviceStudio}
        onClose={() => {
          setServiceStudio(false);
          setSelectedTenantId(null); // Aggiungere questa riga
        }}
        component={
          <ServiceTenant
            selectedStudioId={selectedStudioId}
            group={serviceLevel?.Data?.value}
            filterService={filterService}
            services={dataTenantService?.Data}
            loading={loadingStudio}
          />
        }
      />
      <CoreModal
        width={"80%"}
        height={"80%"}
        state={modalSede}
        onClose={handleCloseSedeModal}
        component={
          <SedeTenant
            tenant={selectedTenant}
            onClose={handleCloseSedeModal}
            registration={registration}
            onCloseTen={onClose}
          />
        }
      />
    </div>
  );
};

export default SwitchTenant;
